export const SET_JOBS = 'SET_JOBS';
export const SET_TASKS = 'SET_TASKS';
export const SET_SELECTED_JOBS = 'SET_SELECTED_JOBS';